export function boysGroupLevel(baseLevel) {
  return `${String(baseLevel || '').trim()} Boys`;
}

export function parseSplitLevel(level) {
  const raw = String(level || '').trim();
  const match = raw.match(/^(.*)\s+Boys$/i);
  if (match) {
    return { baseLevel: match[1].trim(), isBoysGroup: true };
  }
  return { baseLevel: raw, isBoysGroup: false };
}

export function displayLevelTitle(level, splits = {}) {
  const { baseLevel, isBoysGroup } = parseSplitLevel(level);
  if (isBoysGroup) return level;
  if (splits && splits[baseLevel]) return `${baseLevel} Girls`;
  return level;
}
